import { render, staticRenderFns } from "./RefundRulesSection.vue?vue&type=template&id=32a307ec&scoped=true&"
import script from "./RefundRulesSection.vue?vue&type=script&lang=js&"
export * from "./RefundRulesSection.vue?vue&type=script&lang=js&"
import style0 from "./RefundRulesSection.vue?vue&type=style&index=0&id=32a307ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a307ec",
  null
  
)

export default component.exports